import { render, staticRenderFns } from "./ItemsClassCreateForm.vue?vue&type=template&id=6053854e&"
import script from "./ItemsClassCreateForm.vue?vue&type=script&lang=js&"
export * from "./ItemsClassCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports